export default __webpack_public_path__ + "static/media/logo.8a5a1cd3.svg";